import { ITEM_TYPE } from "../../Enums/Enum";

export const formatAmount = (val) => {
  if (val === null || val === undefined || val === "") return "0.00";
  const num = typeof val === "string" ? parseFloat(val.replace(/,/g, "")) : parseFloat(val);
  return (isNaN(num) ? 0 : num).toFixed(2);
};

export const toSignedAddDedAmount = (val, itemType) => {
  const num =
    typeof val === "string" ? parseFloat(val.replace(/,/g, "")) : parseFloat(val);
  const safeNum = isNaN(num) ? 0 : num;
  // return itemType === ITEM_TYPE.Deductions ? -Math.abs(safeNum) : safeNum;
  return itemType === ITEM_TYPE.Deductions ? safeNum : safeNum;
};

export const formatHours = (val) => {
  const decimalHours = parseFloat(val) || 0;
  const isNegative = decimalHours < 0;
  const absHours = Math.abs(decimalHours);
  let hours = Math.floor(absHours);
  let minutes = Math.round((absHours - hours) * 60);
  if (minutes === 60) {
    hours += 1;
    minutes = 0;
  }
  const paddedMinutes = minutes.toString().padStart(2, '0');
  return `${isNegative ? '-' : ''}${hours}:${paddedMinutes}`;
};

export const parseHoursToDecimal = (value) => {
  if (!value) return 0;
  const strVal = String(value).trim();
  if (!strVal.includes(':')) return parseFloat(strVal) || 0;
  const [h, m] = strVal.split(':');
  const hours = parseInt(h, 10) || 0;
  const minutes = parseInt(m, 10) || 0;
  const isNegative = hours < 0 || (hours === 0 && strVal.startsWith('-'));
  const decimal = Math.abs(hours) + (minutes / 60);
  return isNegative ? -decimal : decimal;
};

export const cleanFrequency = (freq) => {
  if (!freq) return "";
  const raw = typeof freq === "object" ? (freq.label || freq.value || "") : String(freq);
  if (!raw || typeof raw !== "string") return "";
  const trimmed = raw.trim();
  const match = trimmed.match(/\(([^)]+)\)/);
  if (match && match[1]) {
    return match[1].trim();
  }
  const cleaned = trimmed.replace(/^\s*\d{1,2}\/\d{1,2}\/\d{2,4}\s*[-–—]\s*\d{1,2}\/\d{1,2}\/\d{2,4}\s*/, "").trim();
  return cleaned.replace(/^\(+|\)+$/g, "").trim();
};